import { styled } from '@linaria/react';
import rgba from 'polished/lib/color/rgba';
import { Card as SSCard, zIndex, colors } from '@spaceshipapp/cambridge';

export const Button = styled.button`
  width: 100%;
  /* sum to 1rem */
  padding-top: 0.9rem;
  padding-bottom: 0.1rem;
  display: flex;
  align-items: center;

  > *:not(:first-child) {
    margin-left: 0.5em;
  }

  span {
    flex-grow: 1;
    text-align: left;
  }

  &:focus {
    outline: none;
  }
`;

export const Title = styled.div`
  padding: 1em;
  font-weight: 600;
  cursor: default;

  ~ li {
    padding-left: 1.5em;
  }
`;

export const Sheet = styled.div`
  position: absolute;
  top: 0;
  padding: 1rem 0;
  z-index: ${zIndex.DROPDOWN};
  width: 100%;
  outline: none;
`;

export const Card = styled(SSCard)`
  box-shadow: 0 0.25em 0.75em ${rgba(colors.text, 0.08)};
  padding: 0;
  max-height: 16em;
  overflow: auto;
`;
